import { HeaderType, RedesignHeaderType } from "../types";
import { OptimizelyLongString, OptimizelyNumber } from "../../../types/optimizely/blocks";

type HeaderTypeValue = OptimizelyNumber['value'] | undefined;
type TitleValue = OptimizelyLongString['value'];

export const getHeaderClassName = (headerType: HeaderTypeValue, isIndustryPerspectiveMode: boolean) => {
    let className = 'hidden md:block text-primary mt-[41px]';

    if (isIndustryPerspectiveMode) {
        className += ' text-[18px] font-serif leading-[1.2] tracking-[-0.2px]';
        return className;
    }

    switch (headerType) {
        case HeaderType.Box:
            className += ' text-[18px] font-normal leading-[1.2] tracking-[-0.2px]';
            break;
        case HeaderType.Centered:
            className += ' text-center text-[18px] font-normal leading-[1.2] tracking-[-0.2px]';
            break; 
        case HeaderType.Serif:
            className += ' text-[18px] font-serif leading-[1.2] tracking-[-0.2px]';
            break;
        case HeaderType.Big:
        default:
            className += ' text-3xl ml-8 md:ml-[62px]';
            break;
    }
    return className;
};

export const getHeaderClassNameRedesign = (headerType: HeaderTypeValue) => {
    let bigHeaderClassName = 'hidden md:block text-3xl text-primary ml-8 md:ml-[62px] mt-[41px]';
    let smallHeaderClassName = 'text-sm md:text-md font-medium text-primary';

    switch (headerType) {
        case RedesignHeaderType.Big:
            return bigHeaderClassName;
        case RedesignHeaderType.Small:
            return smallHeaderClassName;
        default:
            return bigHeaderClassName;
    }
}

export const getGridClass = (count: number) => {
    switch (count) {
        case 1:
        case 2:
            return 'grid-cols-1 md:grid-cols-2';
        case 3:
            return 'grid-cols-1 md:grid-cols-3';
        default:
            return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
    }
};

export const getTitleHtml = (headerType: HeaderTypeValue, title: TitleValue, isIndustryPerspectiveMode: boolean) => {
    if (headerType === HeaderType.Box || headerType === HeaderType.Centered || headerType === HeaderType.Serif || isIndustryPerspectiveMode ) {
      return title;
    }
    const words = title.trim().split(' ');
    if (words.length <= 1) {
        return title;
    }
    const firstWord = words[0];
    const restOfTitle = words.slice(1).join(' ');
    return `${firstWord} <span class="font-bold">${restOfTitle}</span>`;
}
